import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, roleRequired }) {
  const token = localStorage.getItem("access");
  const role = localStorage.getItem("role");

  // ❌ not logged in
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // ❌ wrong role
  if (roleRequired && role !== roleRequired) {
    return <Navigate to="/" replace />;
  }

  // ✅ allowed
  return children;
}

export default ProtectedRoute;